module.exports = __webpack_public_path__ + "static/media/checkCopy.6609a047.svg";